document.addEventListener('click',event=>{const button=event.target.closest('.e92-film__play');if(!button)return;const film=button.closest('[data-e92-film]');const template=film.querySelector('template');if(!template)return;document.querySelectorAll('.e92-film video').forEach(video=>video.pause());const video=template.content.firstElementChild.cloneNode(true);film.replaceChildren(video);video.play().catch(()=>{});});
document.addEventListener('change',event=>{if(event.target.matches('[data-e92-sort]'))event.target.form.requestSubmit();});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.e92-header details[open]').forEach(detail=>{detail.open=false;detail.querySelector('summary').focus();});});
document.addEventListener('click',event=>{document.querySelectorAll('.e92-header details[open]').forEach(detail=>{if(!detail.contains(event.target))detail.open=false;});});

document.addEventListener('click',event=>{const button=event.target.closest('[data-e92-review-scroll]');if(!button)return;const carousel=button.closest('section').querySelector('.e92-reviews');carousel.scrollBy({left:Number(button.dataset.e92ReviewScroll)*carousel.clientWidth*.8,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});

class E92Campaign {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-campaign-track]');
    this.slides = [...section.querySelectorAll('[data-campaign-slide]')];
    this.dots = [...section.querySelectorAll('[data-campaign-dot]')];
    this.index = 0;
    this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches || section.dataset.autoplay !== 'true';
    this.interval = Number(section.dataset.interval) || 7000;
    this.pause = section.querySelector('[data-campaign-pause]');
    this.section.querySelector('[data-campaign-prev]')?.addEventListener('click', () => this.go(this.index - 1));
    this.section.querySelector('[data-campaign-next]')?.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
    this.pause?.addEventListener('click', () => {this.paused = !this.paused; this.sync();});
    this.section.addEventListener('mouseenter', () => this.stop());
    this.section.addEventListener('mouseleave', () => this.schedule());
    this.section.addEventListener('focusin', () => this.stop());
    this.section.addEventListener('focusout', () => this.schedule());
    this.onVisibility = () => document.hidden ? this.stop() : this.schedule();
    document.addEventListener('visibilitychange', this.onVisibility);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(this.section)) {this.stop();document.removeEventListener('visibilitychange', this.onVisibility);}
    });
    this.section.addEventListener('touchstart', event => {this.touchX = event.changedTouches[0].clientX;}, {passive:true});
    this.section.addEventListener('touchend', event => {
      const distance = event.changedTouches[0].clientX - this.touchX;
      if (Math.abs(distance) > 50) this.go(this.index + (distance < 0 ? 1 : -1));
    }, {passive:true});
    this.section.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') {event.preventDefault(); this.go(this.index + 1);}
      if (event.key === 'ArrowLeft') {event.preventDefault(); this.go(this.index - 1);}
    });
    this.section.addEventListener('shopify:block:select', event => {
      const slide = event.target.closest('[data-campaign-slide]');
      if (slide) {this.paused = true; this.go(this.slides.indexOf(slide));}
    });
    this.render();this.sync();
  }
  go(index) {this.index = (index + this.slides.length) % this.slides.length;this.render();this.sync();}
  render() {
    this.track.style.transform = 'translateX(-' + this.index * 100 + '%)';
    this.slides.forEach((slide,i) => {slide.inert = i !== this.index;slide.setAttribute('aria-hidden',String(i !== this.index));});
    this.dots.forEach((dot,i) => {if (i === this.index) dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
  }
  sync() {
    if (this.pause) {this.pause.setAttribute('aria-pressed',String(this.paused));this.pause.setAttribute('aria-label',this.paused ? this.pause.dataset.playLabel : this.pause.dataset.pauseLabel);this.pause.textContent = this.paused ? '▶' : 'Ⅱ';}
    this.schedule();
  }
  stop() {clearTimeout(this.timer);}
  schedule() {this.stop();if (!this.paused && !document.hidden && this.slides.length > 1 && !this.section.matches(':hover') && !this.section.contains(document.activeElement)) this.timer = setTimeout(() => this.go(this.index + 1),this.interval);}
}
const initE92Campaigns = root => root.querySelectorAll('[data-e92-campaign]').forEach(section => {if (!section.dataset.initialized) {section.dataset.initialized = 'true';new E92Campaign(section);}});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initE92Campaigns(document));else initE92Campaigns(document);
document.addEventListener('shopify:section:load', event => initE92Campaigns(event.target));

function setE92GalleryImage(gallery, source, alt, mediaId) {
  const main = gallery.querySelector('.e92-gallery__main');
  if (!main || !source) return;
  const image = new URL(source, window.location.href);
  image.searchParams.set('width', String(Math.min(1600, Math.max(480, Math.ceil(main.clientWidth * window.devicePixelRatio)))));
  main.removeAttribute('srcset');
  if (main.src !== image.href) main.src = image.href;
  main.alt = alt;
  const zoom = gallery.querySelector('[data-e92-view-image]');
  if (zoom) {
    zoom.dataset.e92ViewImage = source;
    zoom.dataset.e92ViewAlt = alt;
    zoom.setAttribute('aria-label', (gallery.dataset.e92EnlargeLabel || 'Enlarge [image] image').replace('[image]', alt));
  }
  const thumbnails = [...gallery.querySelectorAll('[data-e92-gallery-image]')];
  const selected = thumbnails.find(thumb => String(thumb.dataset.e92GalleryMediaId) === String(mediaId)) || thumbnails.find(thumb => thumb.dataset.e92GalleryImage === source);
  thumbnails.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === selected)));
  if (selected) {
    const track = selected.parentElement;
    if (selected.offsetLeft < track.scrollLeft || selected.offsetLeft + selected.offsetWidth > track.scrollLeft + track.clientWidth) {
      track.scrollTo({left: Math.max(0, selected.offsetLeft - track.offsetLeft - (track.clientWidth - selected.offsetWidth) / 2), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
  }
}

function syncE92VariantImage(gallery, variantId) {
  if (!gallery.e92VariantImages) {
    try {gallery.e92VariantImages = JSON.parse(gallery.querySelector('[data-e92-variant-images]').textContent);} catch (_) {return;}
  }
  const variant = gallery.e92VariantImages.find(entry => String(entry.id) === String(variantId));
  if (variant) setE92GalleryImage(gallery, variant.url, variant.alt, variant.mediaId);
}

document.addEventListener('change', event => {
  const picker = event.target.closest('variant-radios, variant-selects');
  let sectionId, variantId;
  if (picker) {
    sectionId = picker.dataset.section;
    const options = picker.tagName === 'VARIANT-RADIOS'
      ? [...picker.querySelectorAll('fieldset')].map(fieldset => fieldset.querySelector('input:checked')?.value)
      : [...picker.querySelectorAll('select')].map(select => select.value);
    try {
      const variants = JSON.parse(picker.querySelector('[type="application/json"]').textContent);
      variantId = variants.find(variant => variant.options.every((value, index) => value === options[index]))?.id;
    } catch (_) {return;}
  } else if (event.target.matches('input[name="id"]')) {
    sectionId = event.target.form?.getAttribute('id')?.replace(/^product-form-(installment-)?/, '');
    variantId = event.target.value;
  }
  if (!sectionId) return;
  const gallery = document.querySelector('[data-e92-gallery-section="' + CSS.escape(sectionId) + '"]');
  if (gallery && variantId) syncE92VariantImage(gallery, variantId);
}, true);

const initE92VariantGalleries = root => root.querySelectorAll('[data-e92-gallery-section]').forEach(gallery => {
  const form = document.getElementById('product-form-' + gallery.dataset.e92GallerySection);
  const variantId = form?.querySelector('input[name="id"]')?.value;
  if (variantId) syncE92VariantImage(gallery, variantId);
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initE92VariantGalleries(document)); else initE92VariantGalleries(document);
document.addEventListener('shopify:section:load', event => initE92VariantGalleries(event.target));

document.addEventListener('click', event => {
  const button = event.target.closest('[data-e92-gallery-image]');
  if (!button) return;
  event.preventDefault();
  const gallery = button.closest('.e92-gallery');
  setE92GalleryImage(gallery, button.dataset.e92GalleryImage, button.dataset.e92GalleryAlt, button.dataset.e92GalleryMediaId);
});

// Product photographs and customer screenshots open within the same page.
let e92ImageViewer;
function getE92ImageViewer() {
  if (e92ImageViewer) return e92ImageViewer;
  const dialog = document.createElement('dialog');
  dialog.className = 'e92-image-viewer';
  dialog.setAttribute('aria-label', 'Image viewer');
  const close = document.createElement('button');
  close.type = 'button'; close.className = 'e92-image-viewer__close';
  close.setAttribute('aria-label', 'Close image viewer'); close.textContent = '×';
  const previous = document.createElement('button');
  previous.type = 'button'; previous.className = 'e92-image-viewer__previous';
  previous.setAttribute('aria-label', 'Previous image'); previous.textContent = '‹';
  const next = document.createElement('button');
  next.type = 'button'; next.className = 'e92-image-viewer__next';
  next.setAttribute('aria-label', 'Next image'); next.textContent = '›';
  const image = document.createElement('img');
  image.className = 'e92-image-viewer__image'; image.decoding = 'async';
  const count = document.createElement('p');
  count.className = 'e92-image-viewer__count'; count.setAttribute('aria-live', 'polite');
  dialog.append(close, previous, image, next, count);
  document.body.append(dialog);
  let entries = [], index = 0, originalOverflow = '', opener;
  const show = () => {
    const entry = entries[index];
    const source = new URL(entry.url, window.location.href);
    source.searchParams.set('width', '2000');
    image.src = source.href; image.alt = entry.alt;
    count.textContent = (index + 1) + ' / ' + entries.length;
    previous.hidden = next.hidden = entries.length < 2;
  };
  const move = direction => { index = (index + direction + entries.length) % entries.length; show(); };
  close.addEventListener('click', () => dialog.close());
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
    }
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = originalOverflow;
    image.removeAttribute('src');
    if (opener?.isConnected) opener.focus({preventScroll:true});
  });
  e92ImageViewer = {
    open(images, activeIndex, trigger) {
      entries = images; index = Math.max(0, activeIndex); opener = trigger;
      originalOverflow = document.documentElement.style.overflow;
      show(); dialog.showModal(); document.documentElement.style.overflow = 'hidden';
      close.focus({preventScroll:true});
    }
  };
  return e92ImageViewer;
}
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-e92-view-image]');
  if (!trigger) return;
  event.preventDefault();
  const gallery = trigger.closest('.e92-gallery');
  let entries, index;
  if (gallery) {
    const thumbnails = [...gallery.querySelectorAll('[data-e92-gallery-image]')];
    entries = thumbnails.map(thumb => ({url:thumb.dataset.e92GalleryImage, alt:thumb.dataset.e92GalleryAlt}));
    index = thumbnails.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true');
  } else {
    const group = trigger.closest('.e92-reviews');
    const images = group ? [...group.querySelectorAll('[data-e92-view-image]')] : [trigger];
    entries = images.map(item => ({url:item.dataset.e92ViewImage, alt:item.dataset.e92ViewAlt || item.getAttribute('aria-label') || item.querySelector('img')?.alt || ''}));
    index = images.indexOf(trigger);
  }
  if (entries.length) getE92ImageViewer().open(entries, index, trigger);
});


